export const DEFAULT_BATCH_FORM_REQUESTED = 'DEFAULT_BATCH_FORM_REQUESTED' as const;
export const DEFAULT_BATCH_FORM_RECEIVED = 'DEFAULT_BATCH_FORM_RECEIVED' as const;
export const DEFAULT_BATCH_FORM_FAILED = 'DEFAULT_BATCH_FORM_FAILED' as const;
export const DEFAULT_BATCH_FORM_TIMEOUTED = 'DEFAULT_BATCH_FORM_TIMEOUTED' as const;
export const BATCH_FORM_FETCHED = 'BATCH_FORM_FETCHED' as const;
export const BATCH_FORM_FETCH_FAILED = 'BATCH_FORM_FETCH_FAILED' as const;
export const BATCH_FORM_ENRICHMENT_RECEIVED = 'BATCH_FORM_ENRICHMENT_RECEIVED' as const;
export const BATCH_FORM_ENRICHMENT_FAILED = 'BATCH_FORM_ENRICHMENT_FAILED' as const;
export const BATCH_FORM_ENRICHMENT_ERROR_DISCARDED = 'BATCH_FORM_ENRICHMENT_ERROR_DISCARDED' as const;
export const BATCH_FORM_SELECT_TOGGLED = 'BATCH_FORM_SELECT_TOGGLED' as const;
export const BATCH_FORM_SELECT_ALL_TOGGLED = 'BATCH_FORM_SELECT_ALL_TOGGLED' as const;
export const BATCH_FORMS_DELETE_REQUESTED = 'BATCH_FORMS_DELETE_REQUESTED' as const;
export const BATCH_FORMS_DELETED = 'BATCH_FORMS_DELETED' as const;
export const BATCH_FORM_RELOAD_REQUESTED = 'BATCH_FORM_RELOAD_REQUESTED' as const;
export const BATCH_FORM_RELOAD_FAILED = 'BATCH_FORM_RELOAD_FAILED' as const;
export const BATCH_QUOTE_ADD_TO_QUEUE = 'BATCH_QUOTE_ADD_TO_QUEUE' as const;
export const BATCH_QUOTE_REQUESTED = 'BATCH_QUOTE_REQUESTED' as const;
export const BATCH_QUOTE_ACKED = 'BATCH_QUOTE_ACKED' as const;
export const BATCH_QUOTE_REQUEST_FAILED = 'BATCH_QUOTE_REQUEST_FAILED' as const;
export const BATCH_QUOTE_RECEIVED = 'BATCH_QUOTE_RECEIVED' as const;
export const BATCH_QUOTE_RESULT_FAILED = 'BATCH_QUOTE_RESULT_FAILED' as const;
export const BATCH_QUOTE_REMOVED = 'BATCH_QUOTE_REMOVED' as const;
export const BATCH_QUOTE_PUSH_BACK_CANCEL_REQUESTED = 'BATCH_QUOTE_PUSH_BACK_CANCEL_REQUESTED' as const;
export const BATCH_QUOTE_PUSH_BACK_CANCELLED = 'BATCH_QUOTE_PUSH_BACK_CANCELLED' as const;
export const BATCH_QUOTE_EXPIRED = 'BATCH_QUOTE_EXPIRED' as const;
export const BATCH_FORMS_CLONE_REQUESTED = 'BATCH_FORMS_CLONE_REQUESTED' as const;
export const BATCH_FORMS_CLONED = 'BATCH_FORMS_CLONED' as const;
export const BATCH_FORM_QUOTE_RELOAD_REQUESTED = 'BATCH_FORM_QUOTE_RELOAD_REQUESTED' as const;
export const BATCH_FORMS_RESTORE_REQUESTED = 'BATCH_FORMS_RESTORE_REQUESTED' as const;
export const BATCH_FORM_ROLLBACK_REQUESTED = 'BATCH_FORM_ROLLBACK_REQUESTED' as const;
export const BATCH_QUOTE_ABORT_REQUESTED = 'BATCH_QUOTE_ABORT_REQUESTED' as const;
export const BATCH_QUOTE_ABORTED = 'BATCH_QUOTE_ABORTED' as const;
export const BATCH_TRADE_AUTH_RECEIVED = 'BATCH_TRADE_AUTH_RECEIVED' as const;
export const BATCH_TRADE_AUTH_TIMEOUT = 'BATCH_TRADE_AUTH_TIMEOUT' as const;
export const BATCH_PREVIOUS_QUOTE_LOADED = 'BATCH_PREVIOUS_QUOTE_LOADED' as const;
export const BATCH_PREVIOUS_QUOTE_LOADING_FAILED = 'BATCH_PREVIOUS_QUOTE_LOADING_FAILED' as const;
export const BATCH_IMPORT_METADATA_REQUESTED = 'BATCH_IMPORT_METADATA_REQUESTED' as const;
export const BATCH_IMPORT_METADATA_RECEIVED = 'BATCH_IMPORT_METADATA_RECEIVED' as const;
export const BATCH_IMPORT_METADATA_FAILED = 'BATCH_IMPORT_METADATA_FAILED' as const;
export const BATCH_IMPORT_FORM_REQUESTED = 'BATCH_IMPORT_FORM_REQUESTED' as const;
export const BATCH_FEES_AND_METRICS_EXPANSION_TOGGLED = 'BATCH_FEES_AND_METRICS_EXPANSION_TOGGLED' as const;
export const BATCH_FEES_AND_METRICS_DATA_SET_CHANGED = 'BATCH_FEES_AND_METRICS_DATA_SET_CHANGED' as const;
